import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import {
  ElderPaneSubtitleComponent,
  ElderPlugParentFormDirective,
  ElderQuantityInputControlComponent,
  ElderSelectComponent,
  ElderUnitSelectDirective,
  ElderUnitService,
  ElderValidationErrorDirective,
  Unit,
  UnitDimension,
  UnitInfo,
  UnitRegistry,
} from '@elderbyte/ngx-starter'
import { FormsModule } from '@angular/forms'
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { PackageTypeDetailController } from '../package-type-detail-controller.service'
import { Observable } from 'rxjs'
import { PackageType } from '../../package-type'
import { AsyncPipe } from '@angular/common'
import { IdValidator } from '../../../../../features/validators/id-validator'

@Component({
  selector: 'app-package-type-general',
  imports: [
    ElderPaneSubtitleComponent,
    ElderQuantityInputControlComponent,
    ElderValidationErrorDirective,
    ElderUnitSelectDirective,
    ElderSelectComponent,
    FormsModule,
    MatError,
    MatFormField,
    MatInput,
    MatLabel,
    ElderTranslatePipe,
    AsyncPipe,
    ElderPlugParentFormDirective,
  ],
  templateUrl: './package-type-general.component.html',
  styleUrl: './package-type-general.component.scss',
})
export class PackageTypeGeneralComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly controller = inject(PackageTypeDetailController)

  public readonly idValidatorPattern = IdValidator.pattern
  readonly defaultLengthDimension = UnitDimension.Length
  readonly defaultWeightDimension = UnitDimension.Mass
  readonly initialLengthUnit = this.controller.packageType.dimensionUnit
  readonly initialWeightUnit = this.controller.packageType.weightUnit
  dimensionUnitInfo: UnitInfo
  weighUnitInfo: UnitInfo

  constructor() {
    this.dimensionUnitInfo = new UnitInfo(
      this.defaultLengthDimension,
      this.initialLengthUnit,
      this.initialLengthUnit,
      null
    )
    this.weighUnitInfo = new UnitInfo(
      this.defaultWeightDimension,
      this.initialWeightUnit,
      this.initialWeightUnit,
      null
    )
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  public get packageType$(): Observable<PackageType> {
    return this.controller.packageType$
  }

  public get creationMode$(): Observable<boolean> {
    return this.controller.creationMode$
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  changeWeightUnit(weightUnitInfo: UnitInfo): void {
    this.controller.packageType.weightUnit = weightUnitInfo.unit
  }

  changeDimensionUnit(dimensionUnitInfo: UnitInfo): void {
    this.controller.packageType.dimensionUnit = dimensionUnitInfo.unit
  }
}
